import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import AdminLogin from "../layouts/AdminPortal/AdminAuthentication/AdminLogin";
import SidebarAdmin from "../layouts/AdminPortal/AdminPortalLayout/AdminLayout";
import AdminDashboard from "../layouts/AdminPortal/AdminDashboard/AdminDashboards";
import AdminUsers from "../layouts/AdminPortal/AdminUsersPage/AdminUsers";
import AdminDataSources from "../layouts/AdminPortal/DataSourcePage/DataSources";
import AdminSubscriptions from "../layouts/AdminPortal/Subscriptions/Subscriptions";
import CreateInvoice from "../layouts/AdminPortal/Subscriptions/CreateInvoice";
import ViewInvoice from "../layouts/AdminPortal/Subscriptions/ViewInvoice";
import AdminActivityLogs from "../layouts/AdminPortal/ActivityLogsPage/ActivityLogs";
import AdminAnnouncements from "../layouts/AdminPortal/AnnouncementsPage/Announcements";
import CreateAnnouncement from "../layouts/AdminPortal/AnnouncementsPage/CreateAnnouncement";
import EditAnnouncement from "../layouts/AdminPortal/AnnouncementsPage/EditAnnouncement";
import AdminSettings from "../layouts/AdminPortal/AdminSettings/Settings";
import PipelineDashboard from "../layouts/AdminPortal/PipelineHealthPage/PipelineDashboard";
import UsageLimits from "../layouts/AdminPortal/UsageLimits/UsageMonitoring";

const AdminRoutes: React.FC = () => (
  <Routes>
    <Route path="log-in" element={<AdminLogin />} />
    <Route path="/" element={<SidebarAdmin />}>
      <Route index element={<Navigate to="dashboard" replace />} />
      <Route path="dashboard" element={<AdminDashboard />} />
      <Route path="users" element={<AdminUsers />} />
      <Route path="data-sources" element={<AdminDataSources />} />
      <Route path="subscriptions" element={<AdminSubscriptions />} />
      <Route path="create-invoice" element={<CreateInvoice />} />
      <Route path="invoice">
        <Route path="create" element={<CreateInvoice />} />
        <Route path="view/:invoiceId" element={<ViewInvoice />} />
        <Route path="edit/:invoiceId" element={<CreateInvoice />} />
      </Route>
      <Route path="activity-logs" element={<AdminActivityLogs />} />
      <Route path="announcements" element={<AdminAnnouncements />} />
      <Route path="settings" element={<AdminSettings />} />
      <Route path="pipeline-health" element={<PipelineDashboard />} />
      <Route path="create-announcement" element={<CreateAnnouncement />} />
      <Route path="edit-announcement" element={<EditAnnouncement />} />
      <Route path="quota-management" element={<UsageLimits />} />
    </Route>
  </Routes>
);

export default AdminRoutes;
